import React from 'react';
import { motion } from 'framer-motion';
import Header from '../components/Header';
import Hero from '../components/Hero';
import Services from '../components/Services';
import Features from '../components/Features';
import Process from '../components/Process';
import CaseStudies from '../components/CaseStudies';
import Team from '../components/Team';
import CTA from '../components/CTA';
import Footer from '../components/Footer';

const LandingPage = () => {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.5 }}
      className="min-h-screen bg-gradient-to-br from-slate-900 via-purple-900 to-slate-900"
    >
      <Header />
      <Hero />
      <Services />
      <Features />
      <Process />
      <CaseStudies />
      <Team />
      <CTA />
      <Footer />
    </motion.div>
  );
};

export default LandingPage;